import { RolesEnum } from "app/shared/enums/roles.enum";

export class RoleDTO {
  id: RolesEnum;
  name: string;
  description: string;

  constructor(init?: RoleDTO) {
    Object.assign(this, init);
  }
}

export class RoleVM {
  id: RolesEnum;
  name: string;
  checked?: boolean;
  disabledChecked?: boolean;

  constructor(init?: RoleVM) {
    Object.assign(this, init);
  }
}
